// src/utils/getFechaHermosillo.js

async function getDateHour() {
  const url = "https://worldtimeapi.org/api/timezone/America/Hermosillo";

  try {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error("Error en API");

    const data = await res.json();
    const fechaInternet = new Date(data.datetime);

    return formatearFecha(fechaInternet, "internet");
  } 
  catch (error) {
    console.warn("⚠️ No se pudo obtener la hora de internet, usando hora local.");
    return formatearFecha(new Date(), "local");
  }
}

function formatearFecha(dateObj, fuente) {
  let anio = dateObj.getFullYear();
  let mes = (dateObj.getMonth() + 1).toString().padStart(2, "0");
  let dia = dateObj.getDate().toString().padStart(2, "0");

  let horas = dateObj.getHours().toString().padStart(2, "0");
  let minutos = dateObj.getMinutes().toString().padStart(2, "0");
  let segundos = dateObj.getSeconds().toString().padStart(2, "0");

  return {
    fecha: `${anio}/${mes}/${dia}`,
    hora: `${horas}:${minutos}:${segundos}`,
    fuente: fuente
  };
}

export { getDateHour };
